import { Chip, ChipProps, Theme, withStyles } from '@material-ui/core';
import { forwardRef } from 'react';
import { ColoredCommonProps } from './common';

interface ColoredChip {
  <C extends React.ElementType>(
    props: ChipProps<C, { component?: C }> & ColoredCommonProps & { iconOnly?: boolean }
  ): JSX.Element;
}

export const ColoredChip = withStyles<'root', any, ColoredCommonProps>((theme: Theme) => ({
  root: ({ colored, coloredHover = colored }) =>
    colored
      ? {
          color: theme.palette.getContrastText(colored),
          background: colored,
          '&:hover': {
            backgroundColor: coloredHover,
          },
        }
      : {},
  label: ({ iconOnly }) => (iconOnly ? { paddingLeft: 0 } : {}),
  icon: ({ colored, coloredHover = colored }) =>
    colored
      ? {
          color: theme.palette.getContrastText(colored),
          '&:hover': { color: theme.palette.getContrastText(coloredHover) },
        }
      : {},
  deleteIcon: ({ colored, coloredHover = colored }) =>
    colored
      ? {
          color: theme.palette.getContrastText(colored),
          '&:hover': { color: theme.palette.getContrastText(coloredHover) },
        }
      : {},
}))(
  forwardRef(({ colored, coloredHover, iconOnly, ...props }: any, ref) => (
    <Chip {...props} ref={ref} />
  ))
) as ColoredChip;
